exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ":host {\n  overflow: auto;\n  -webkit-overflow-scrolling: touch; }\n\nelectra-sub-page-header {\n  height: 32px;\n  opacity: 0;\n  pointer-events: none;\n  width: 100%; }\n\n:host > iframe {\n  height: 100%;\n  position: absolute;\n  min-width: 100%;\n  width: 1px; }\n\n/* Desktop */\n:host.desktop > electra-sub-page-header {\n  opacity: 1;\n  pointer-events: all; }\n\n:host.desktop > iframe {\n  height: calc(100% - 32px);\n  top: 32px; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/electraLib/component/iab/iab.component.scss
// module id = 406
// module chunks = 1